import Backbone from 'backbone'
import _ from 'lodash'
import template from 'scoreboard/dashboards/edit/chart-or-report-dialog-editor.hbs'
import reportsMeta from 'scoreboard/reports/reports-meta'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'

const ReportDialogEditor = Backbone.View.extend({

	/**
	 * @type ScorecardReportModel (Or some subclass)
	 */
	model: null,

	tagName: 'form',

	className: 'report-dialog-editor',

	initialize: function(options = {}) {
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: true
		})

		let reportType = this.model.get('subtype')
		var EditView = reportsMeta[reportType].form
		this.editor = new EditView({
			model: this.model,
			formView: this.formView,
			embedded: true
		})
	},

	render: function() {
		this.$el.empty().append(template({
			title: i18n.get('report.customReport.editReport'),
			submitLabel: i18n.get('common.done')
		}))
		this.maxDimensions = true
		this.$('.editor').append(this.editor.el)
		this.editor.render()

		this.formView.start()
	},

	submit: function() {
		this.trigger('done', this.model)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.editor], 'remove')
	}
})

export default ReportDialogEditor
ReportDialogEditor.__filename__ = 'dashboards/widgets/report/report-dialog-editor.js'
